import dayjs from 'dayjs'

class Auth {
    checkToken() {
        let token = localStorage.getItem('ttt')
        if (token) {
            let expire = token.substr(-10)
            let ed = dayjs(expire)
            if (ed.isBefore(dayjs())) {
                localStorage.removeItem('ttt')
                return false
            } else {
                return true
            }
        } else {
            return false
        }
    }

    refreshToken() {
        let token = this.getToken()
        this.setToken(token)
    }
    setToken(token:string) {
        localStorage.setItem('ttt', token + '/' + dayjs().add(7, 'day').format('YYYY-MM-DD'))
    }
    getToken() {
        let token = localStorage.getItem('ttt')
        if (token) {
            return token.split('/')[0]
        }
        return ''
    }
    
}
export default new Auth()